// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__U6hIk","description":"MealItem_description__ZCwvh","price":"MealItem_price__PX991"};